import { gql } from '@apollo/client';

export const GET_MERCHANT_OPTIONS = gql`
  query ManualBonusMerchantFilterOptions ($input: MerchantFilterInput!) {
    manualBonusMerchantfiltersV2 (input: $input) {
      merchantOptions 
  }
}
`;
